import { Box, Grid, Typography } from '@mui/material'
import { fileUrl } from 'api/api'
import ManageWebApi from 'api/application/manageWeb'
import { BannerProps } from 'api/application/manageWeb-interface'
import Loading from 'component/Loading'
// import UploadImage from 'component/Upload/UploadImage'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'
import AlertModal from 'new-components/modal/alert-modal'
import UploadImage from 'new-components/upload/upload-image'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

type ManageWebBannerProps = {
    setBannerImg: (img: string) => void
    bannerImg: string
}


const Banner = (props: ManageWebBannerProps) => {
    const { t } = useTranslation()
    const maxHeight = 700
    const maxWidth = 1440
    const [load, setLoad] = useState<boolean>(true)
    const [banner, setBanner] = useState<any>({})
    const [bannerId, setBannerId] = useState<any>({})
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)

    const loadData = async () => {
        setLoad(true)
        await ManageWebApi.getBanner().then((res) => {
            setBanner(res.data)
            setBannerId(res.data)
        }).catch(() => {
            return
        }).finally(() => {
            setLoad(false)
        })
    }

    useEffect(() => {
        loadData()
    }, [])



    const handleDel = () => {
        ManageWebApi.delBanner(banner.bannerId).then((resp) => {
            if (resp === "pass") {
                setIsOpenAlertModal(false)
                notiSuccess(t(`MANAGE_WEB.BANNER.DEL_SUC`))
                setBanner({})
                setBannerId({})
                loadData()
            } else {
                notiError(t(`MANAGE_WEB.BANNER.SAVE_ERROR`))
            }
        })
    }

    const uploadNewsImageSign = (files: any) => {
        if (files[0]) {
            const file = files[0];
            const fileName = file.name.split(".");
            const detailImage = {
                base64: "",
                type: bannerId?.fileType || "",
                fileExtension: fileName[fileName.length - 1],
                fileSize: file.size.toString(),
                fileId: bannerId?.bannerId || 0,
            };

            const reader: any = new FileReader();
            reader.addEventListener("load", () => {
                const image = new Image();
                image.src = reader?.result as string;
                image.addEventListener("load", () => {
                    const width = image.width;
                    const height = image.height;

                    if (maxHeight < height || maxWidth < width) {
                        const errorWidth = maxWidth < width && ` ${t('MANAGE_WEB.BANNER.ERROR_WIDTH')} ${maxWidth} ` || ''
                        const errorHeight = maxHeight < height && ` ${t('MANAGE_WEB.BANNER.ERROR_HEIGHT')} ${maxHeight} ` || ''
                        const error = `Banner ${errorWidth} ${maxHeight < height && maxWidth < width && ` ${t('MANAGE_WEB.CONNECTOR.AND')} ` || ''} ${errorHeight}`
                        notiError(error)
                    } else {
                        const base64 = reader.result.split(",");
                        detailImage.base64 = base64.length > 0 ? base64[base64.length - 1] : reader.result;
                        const newData = { ...banner, ...detailImage, base64Show: reader.result, }
                        setBanner(newData)
                    }
                });
            });
            reader.readAsDataURL(file);
        }
    };

    const onBannerRefresh = () => {
        loadData()
    }


    const onSaveBanner = async () => {
        const newPayload: BannerProps = {
            bannerId: bannerId?.bannerId || 0,
            base64: banner?.base64 || '',
            type: banner?.type || '',
            fileExtension: banner?.fileExtension || '',
            fileSize: banner?.fileSize || ''
        }
        if (newPayload.base64) {
            await ManageWebApi.saveBanner(newPayload).catch(() => {
                return
            }).then(() => {
                notiSuccess(t(`MANAGE_WEB.BANNER.SUCCESS_IMG`))
                props.setBannerImg(banner?.base64Show || '')
                loadData()
            })
        } else {
            return notiError(t(`MANAGE_WEB.BANNER.NOTI_IMAGE`))
        }
    }

    const onRenderImg = () => {
        if (props?.bannerImg && props?.bannerImg !== '') {
            return props?.bannerImg
        } else {
            return `${fileUrl}/${banner?.filePath}/${banner?.fileName}`
        }
    }

    return (
        <>
            <Loading show={load} />
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`MANAGE_WEB.TITLE_DEL`)}
                message={t('MANAGE_WEB.BANNER.NOTI_DEL')}
                type="error"
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: handleDel, title: t('BUTTON.SUBMIT') }}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                {!load && (
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={banner?.filePath ? 6 : 12} md={4} xl={6}>
                            <Typography
                                variant="h6"
                                sx={{
                                    fontSize: { xs: 18, sm: 20 },
                                    fontWeight: 600,
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    textAlign: { xs: 'left', sm: 'left' },
                                }}
                            >
                                {t(`MANAGE_WEB.BANNER.TITLE`)}
                            </Typography>
                        </Grid>
                        <Grid item xs={banner?.filePath ? 6 : 12} md={8} xl={6} display='flex' justifyContent={'flex-end'}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: banner?.filePath ? 'flex-start' : 'flex-end',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                }}
                            >
                                {banner?.filePath ? (
                                    <MainButton
                                        variant="contained"
                                        type="danger"
                                        title={t(`MANAGE_WEB.BANNER.BTN_DEL`)}
                                        onClick={() => setIsOpenAlertModal(true)}
                                        style={{ width: 120 }}
                                    />
                                ) : (
                                    <>
                                        <MainButton
                                            variant="outlined"
                                            type="secondary"
                                            title={t(`MANAGE_WEB.BANNER.BTN_CANCEL`)}
                                            onClick={onBannerRefresh}
                                            disabled={!banner?.base64Show}
                                            style={{ width: 120 }}
                                        />
                                        <MainButton
                                            variant="contained"
                                            type="primary"
                                            title={t(`MANAGE_WEB.BANNER.BTN_SAVE`)}
                                            onClick={onSaveBanner}
                                            disabled={!banner?.base64Show}
                                            style={{ width: 120 }}
                                        />
                                    </>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                )}

                {!load &&
                    <Box sx={{ marginTop: '32px', height: banner?.filePath || banner?.base64Show ? '100%' : '90%', overflow: 'auto' }}>
                        {banner?.filePath &&
                            <img
                                src={onRenderImg()}
                                style={{ width: "100%" }}
                            />
                            ||
                            <Box>
                                <UploadImage
                                    setValue={uploadNewsImageSign}
                                    pathFile={banner?.base64Show || banner?.filePath || ''}
                                    canDelete
                                    onDelete={() => setBanner({})}
                                    height={'calc(100vh - 380px)'}
                                    maxWidth={maxWidth}
                                    maxHeight={maxHeight}
                                />
                                <Box color={"#BBBBBB"} marginTop='8px' textAlign={'left'} width={'100%'}>
                                    {'('}{t(`MANAGE_WEB.BANNER.FILESIZE`)}{` ${maxWidth} x ${maxHeight} px)`}
                                </Box>
                            </Box>
                        }
                    </Box>
                }
            </Box>
        </>
    )
}

export default Banner